export enum UserRoles {
    Principal = 4,
    CpseAdmin = 15,
    ChairPerson = 7,
    SupervisorOfNursing = 141,
    RSC_AppliedBehaviorAnalyst = 81,
    RSI_AppliedBehaviorAnalyst = 160,
    SpecialEducationTeacher = 105
}

export const UserRole = UserRoles;